<template>
  <div v-if="hasContent" class="content-sticky">
    <component
      :is="component.component"
      v-for="component in components"
      :key="component.id"
      v-bind="{ ...attrs, ...component.propData }"
    />
  </div>
</template>

<script setup lang="ts">
import RandomUtils from "@utils/random.utils";
import { computed, onMounted, ref, useAttrs } from "vue";
import { useVm } from "@utils/vm.ts";

// Composables
const { vm, vmExpose } = useVm();
const attrs = useAttrs();

// Data
const components = ref([]);

// Computed
const hasContent = computed(() => {
  return components.value.length > 0;
});

// Methods
const set = (component, propData = {}) => {
  const PREFIX = "sticky_";
  const id = PREFIX + RandomUtils.randomId();
  components.value = [
    {
      id: id,
      component: component,
      propData: propData,
    },
  ];
  return id;
};

const remove = () => {
  components.value = [];
};

// Mounted
onMounted(() => {
  // TODO: kaiwen-check $attrs has any listeners
  vm.$stickpanel.register(vm);
});

vmExpose({
  set,
  remove,
  components,
});
</script>
